import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild } from '@angular/core';
import { CommonModule, formatDate  } from '@angular/common';
import { Router } from '@angular/router';
import { InicioService } from '../../services/inicio.service';
import { ModalComponent } from "../modal/modal.component";
import { appsettings } from '../../settings/appsettings';
import { ListaOcupacionComponent } from "./lista-ocupacion/lista-ocupacion.component";

@Component({
  selector: 'app-catalago',
  standalone: true,
  imports: [ModalComponent, CommonModule, ListaOcupacionComponent],
  templateUrl: './catalago.component.html',
  styleUrl: './catalago.component.css'
})
export class CatalagoComponent implements OnInit {
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  private srvLogin = inject(InicioService);
  public rutas = inject(Router);
  url = appsettings.apiUrl;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  errorMessage: string = '';
  motoresList: any = [];
  datos_motor: any;
  isOcupacion: boolean = false;
  user: any;
  logeo: boolean = false;
  token: string = ''


  ngOnInit(): void {
    if (typeof window !== 'undefined' && !!localStorage.getItem('token')) {
      const storedUser = localStorage.getItem('usuSesion');
      if (storedUser != null) {
        this.user = JSON.parse(storedUser);
        this.srvLogin.updateLogeo(this.user);
      } else {
        // Si no hay usuario almacenado, realizar la lógica de autenticación
        this.user = null;
        this.srvLogin.updateLogeo(this.user);
        //console.log('no hay usuario')
      }
    }
    //console.log('no hay usuario: ', this.user)
    this.srvLogin.user$.subscribe(user => {
      this.user = user;
    });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.srvLogin.listarMotores().subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.motoresList = rs.data;
        console.log(rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  muestraOcupacion(datos: any) {
    this.isOcupacion = true;
    this.datos_motor = datos;
  }


  atras(){
    if(this.user){
      this.rutas.navigate(['/panel-admin']);
    }
    else{
      this.rutas.navigate(['/']);
    }
  }

  volver(rsl: any) {
    this.isOcupacion = rsl.value;
  }


}
